import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getStates } from './thunks'

const initialState: CountryStates = {
  states: [],
  status: 'idle',
  error: null,
}

const slice = createSlice({
  name: 'states',
  initialState,
  reducers: {
    clearStates: (state) => {
      state.states = []
    },
    clearCountryStates: (state, action) => {
      const countryName = action.payload.name
      state.states = state.states.filter((state: CountryState) => state.stateCountry !== countryName)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStates.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getStates.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getStates.fulfilled, (state, action) => {
        state.status = 'succeeded'
        const sortedStates = state.states.concat(action.payload).sort(function (a, b) {
          if (a.stateCountry !== b.stateCountry) {
            return a.stateCountry.localeCompare(b.stateCountry)
          }
          return a.stateName.localeCompare(b.stateName)
        })
        state.states = [...new Map(sortedStates.map((state: CountryState) => [state.id, state])).values()]
      })
  },
})

export const { clearStates, clearCountryStates } = slice.actions

export const selectStates = (state: RootState): CountryStates => state.countryStates

export default slice.reducer
